import { ReactNode, useRef } from 'react';
import { useDrag } from 'react-dnd';

import { PropertyView } from '../../../types';

/**
 * Drag用コンポーネントのProps
 * @TODO item側の型についてはデータカタログのJSONフォーマットが決まり次第修正する
 */
export type DataCatalogDragBoxProps = {
  children: ReactNode;
  item?: PropertyView;
};

/**
 * Drag用コンポーネント
 * @param children ドラッグ時のコンテンツ
 * @param item react-dndを使用したときにDrop側に渡すプロパティ
 */
export function DataCatalogDragBox({
  children,
  item,
}: DataCatalogDragBoxProps) {
  const dragPreviewRef = useRef<HTMLDivElement>(null);
  const dragRef = useRef<HTMLDivElement>(null);
  const [, drag, dragPreview] = useDrag(() => ({
    type: 'BOX',
    item: item,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));
  drag(dragRef);
  dragPreview(dragPreviewRef);

  return (
    <div ref={dragPreviewRef}>
      <div role="Handle" ref={dragRef}>
        {children}
      </div>
    </div>
  );
}
